import React from 'react'

function MyWallet() {
  return (
    <div>
      my wallet
    </div>
  )
}

export default MyWallet
